export default __webpack_public_path__ + "static/media/document_icon.1947136e.svg";